import styled from 'styled-components';
import { ModalSize } from './types';

export const ModalOverlay = styled.div<{ zIndex?: number }>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${({ zIndex }) => zIndex ?? 12300};
    padding: 1rem;

    /* Add a unique identifier for interaction detection */
    &[data-modal-overlay] {
        pointer-events: auto;
    }
`;

export const ModalContainer = styled.div<{ size: ModalSize }>`
    background: white;
    border-radius: 8px;
    box-shadow:
        0 20px 25px -5px rgba(0, 0, 0, 0.1),
        0 10px 10px -5px rgba(0, 0, 0, 0.04);
    max-height: 90vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    pointer-events: auto;

    ${({ size }) => {
        switch (size) {
            case 'small':
                return `
                    width: 100%;
                    max-width: 400px;
                `;
            case 'large':
                return `
                    width: 100%;
                    max-width: 800px;
                `;
            case 'xlarge':
                return `
                    width: 100%;
                    max-width: 1200px;
                `;
            default:
                return `
                    width: 100%;
                    max-width: 600px;
                `;
        }
    }}
`;

export const ModalHeader = styled.div`
    padding: 1.5rem 1.5rem 1rem 1.5rem;
    font-size: 1.125rem;
    font-weight: 600;
    color: #111827;
    flex-shrink: 0;
`;

export const ModalBody = styled.div`
    padding: 1rem 1.5rem 1.5rem 1.5rem;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #6b7280;
    cursor: pointer;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        color: #374151;
        background-color: #f3f4f6;
    }

    &:focus {
        outline: 2px solid #3b82f6;
        outline-offset: 2px;
    }
`;
